// extracted by mini-css-extract-plugin
module.exports = {"root":"Notifications_root__h3YfH","notification":"Notifications_notification__5e8Td","openNotification":"Notifications_openNotification__IZ_JA"};